const SYSTEMS = [
	{ name: "Visa", test: (n) => n.startsWith("4"), className: "visa" },
	{ name: "Mastercard", test: (n) => /^5[1-5]/.test(n) || /^2(22[1-9]|2[3-9][0-9]|[3-6][0-9]{2}|7[0-1][0-9]|720)/.test(n), className: "mastercard" },
	{ name: "МИР", test: (n) => /^2(20|21|220[0-4])/.test(n), className: "mir" },
	{ name: "Maestro", test: (n) => /^(50|56|57|58|59|63|67|68|69)/.test(n), className: "maestro" },
	{ name: "American Express", test: (n) => /^3[47]/.test(n), className: "amex" },
	{ name: "UnionPay", test: (n) => /^62/.test(n), className: "unionpay" },
]

export const getPaymentSystem = (cardNumber) => {
	if (!cardNumber) return { name: "—", className: "unknown" }

	const normalized = String(cardNumber).replace(/\D/g, "")
	const found = SYSTEMS.find((system) => system.test(normalized))

	return found ? { name: found.name, className: found.className } : { name: "—", className: "unknown" }
}
